import {http} from './config/config-relation-register'
export default{    
    salvar:(token, meioAmbiente)=>{
        return http.post('cad-meio-ambientes', meioAmbiente,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizar:(token, meioAmbiente)=>{
        return http.put(`cad-meio-ambientes/${meioAmbiente.id_cad_meio_ambiente}`,meioAmbiente,{
            headers:{
                'Authorization':token
            }
        })
    },
    findByProduto:(token, id)=>{
        return http.get(`cad-meio-ambientes/produto/${id}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, id)=>{
        return http.delete(`cad-meio-ambientes/${id}`,{
            headers:{
                'Authorization':token
            }
        })
    },
}